import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useContent } from "./hooks/useContent";
import "./styles/globals.css";

import Navbar      from "./components/Navbar";
import Footer      from "./components/Footer";
import LeadPopup   from "./components/LeadPopup";
import Home        from "./pages/Home";
import Services    from "./pages/Services";
import About       from "./pages/About";
import TrackRecord from "./pages/TrackRecord";
import Network     from "./pages/Network";
import WhyUs       from "./pages/WhyUs";
import Insights    from "./pages/Insights";
import Contact     from "./pages/Contact";

function Loader() {
  return (
    <div style={{height:"100vh",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",background:"#0d0807",gap:20}}>
      <span style={{fontFamily:"'Cormorant Garamond',serif",fontSize:"1rem",letterSpacing:".4em",textTransform:"uppercase",color:"#8B7355",animation:"pulse 1.8s infinite"}}>
        PR Elite Estate
      </span>
      <div style={{width:40,height:1,background:"linear-gradient(to right,transparent,#8B1A1A,transparent)",animation:"expand 1.4s ease-in-out infinite"}}/>
      <style>{`
        @keyframes pulse  { 0%,100%{opacity:.35} 50%{opacity:1} }
        @keyframes expand { 0%,100%{transform:scaleX(.3)} 50%{transform:scaleX(1)} }
      `}</style>
    </div>
  );
}

function RouteWatcher() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const titles = {
      "/":             "PR Elite Estate | Real Estate Advisory",
      "/services":     "Services | PR Elite Estate",
      "/about":        "About | PR Elite Estate",
      "/track-record": "Strategic Mandates | PR Elite Estate",
      "/network":      "Our Clients | PR Elite Estate",
      "/why-us":       "Why PR Elite | PR Elite Estate",
      "/insights":     "Insights | PR Elite Estate",
      "/contact":      "Contact | PR Elite Estate",
    };
    document.title = titles[location.pathname] || "PR Elite Estate";
  }, [location.pathname]);
  return null;
}

function Layout({ content }) {
  const location = useLocation();
  return (
    <>
      <RouteWatcher/>
      <Navbar brand={content.brand} nav={content.nav}/>
      <LeadPopup/>

      <main key={location.pathname} style={{animation:"pageIn .5s cubic-bezier(.22,1,.36,1) both"}}>
        <Routes>
          <Route path="/"             element={<Home        data={content.home}        />}/>
          <Route path="/services"     element={<Services    data={content.services}    />}/>
          <Route path="/about"        element={<About       data={content.about}       />}/>
          <Route path="/track-record" element={<TrackRecord data={content.trackRecord} />}/>
          <Route path="/network"      element={<Network     data={content.network}     />}/>
          <Route path="/why-us"       element={<WhyUs       data={content.whyUs}       />}/>
          <Route path="/insights"     element={<Insights    data={content.insights}    />}/>
          <Route path="/contact"      element={<Contact     data={content.contact}     />}/>
          <Route path="*"             element={<Home        data={content.home}        />}/>
        </Routes>
      </main>

      {/* ✅ WhatsApp Floating Button */}
      <a
        href="https://wa.me/916363236215?text=Hello%20PR%20Elite%20Estate,%20I%20would%20like%20to%20discuss%20a%20mandate."
        target="_blank"
        rel="noopener noreferrer"
        className="wa-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>

      <Footer brand={content.brand} footer={content.footer}/>

      <style>{`
        @keyframes pageIn {
          from { opacity:0; transform:translateY(16px) }
          to   { opacity:1; transform:none }
        }
      `}</style>
    </>
  );
}

export default function App() {
  const { content, loading, error } = useContent();
  if (loading) return <Loader/>;
  if (error)   return <div style={{color:"#8B1A1A",padding:40,fontFamily:"monospace",background:"#0d0807",minHeight:"100vh"}}>Error: {error}</div>;
  return <BrowserRouter><Layout content={content}/></BrowserRouter>;
}
